import { useMapMarkerStore, usePipedriveStore, useSaleCompStore } from "..";
import { showErrorToast, showSuccessToast } from "../components/ToastContainer";
import ISaleComp, { ISaleCompState } from "../interfaces/ISaleComp";

const useSaleCompUpdate = (): (saleComp: ISaleComp, saleCompState: ISaleCompState) => Promise<void> => {
    const saleCompStore = useSaleCompStore();
    const pipedriveStore = usePipedriveStore();
    const mapMarkerStore = useMapMarkerStore();

    return async (saleComp: ISaleComp, saleCompState: ISaleCompState): Promise<void> => {
        try {
            await saleCompStore.updateSaleComp({
                ...saleComp,
                ...saleCompState,
                address: saleCompState.address!,
                saleDate: saleCompState.saleDate!,
                salePrice: saleCompState.salePrice!,
                grossPerAcre: saleCompState.grossPerAcre!,
                parcelSizeAcres: saleCompState.parcelSizeAcres!,
                landSizeUsable: saleCompState.landSizeUsable!,
                pipedriveBuyerId: !saleCompState.isBuyerIndividual ? await pipedriveStore.getOrCreatePipedriveOrganizationId(saleCompState.buyerName) : null,
                buyerName: saleCompState.isBuyerIndividual ? saleCompState.buyerName : null,
                pipedriveSellerId: !saleCompState.isSellerIndividual ? await pipedriveStore.getOrCreatePipedriveOrganizationId(saleCompState.sellerName) : null,
                sellerName: saleCompState.isSellerIndividual ? saleCompState.sellerName : null,
                pipedriveBrokerageId: !saleCompState.isBrokerageIndividual ? await pipedriveStore.getOrCreatePipedriveOrganizationId(saleCompState.brokerageName) : null,
                brokerageName: saleCompState.isBrokerageIndividual ? saleCompState.brokerageName : null,
                centerPoint: mapMarkerStore.coordinates!,
            });

            showSuccessToast();
        } catch (e) {
            showErrorToast();
            throw e;
        }
    };
};

export default useSaleCompUpdate;